<template>
	<el-dialog title="确定关闭规则总开关？" :visible.sync="visible" width="400px" :before-close="beforeClose">
		<div class="flex-row flex-align-start yx-color-text-primary font-h4-regular">
			<i class="el-icon-warning  yx-color-warning mt-4"></i>
			<p class="ml-4">开关关闭后将无法进行新样品订单的协作，不影响历史历史已发起的协作申请，确认关闭？</p>
		</div>
		<div slot="footer">
			<el-button @click="beforeClose">取消</el-button>
			<el-button type="primary" @click="confirm">确认关闭</el-button>
		</div>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			visible: false,
		};
	},
	methods: {
		show() {
			this.visible = true;
		},
		beforeClose() {
			this.visible = false;
		},
		async confirm() {
			this.$emit('closeRules', 0);
			this.beforeClose();
		},
	},
};
</script>
<style lang="less" scoped></style>
